import React from 'react'
import { Tooltip } from 'antd'
import type { CsvCompareRow } from '../api/compare-data-api'
import {
  formatDisplayValue,
  getFieldError,
  isDiffField,
} from '../utils/compareDataHelpers'
import styles from '../PlanManagementV3.module.scss'

export default function DiffCellRenderer({
  row,
  fieldKey,
}: {
  row: CsvCompareRow
  fieldKey: string
}) {
  const uploaded = row.fieldCompare[fieldKey]?.csvValue
  const fieldError = getFieldError(row, fieldKey)
  const hasDiff = isDiffField(row, fieldKey)

  if (fieldError) {
    const displayValue = formatDisplayValue(uploaded)
    const isEmpty = displayValue === ''
    // When the value is empty there's no text to hover over, so stretch the
    // span across the whole cell (matching diffCellChanged) to keep the
    // tooltip reachable anywhere on the highlighted background.
    const errorClassName = [
      styles.diffCellText,
      styles.diffCellError,
      isEmpty ? styles.diffCellErrorEmpty : null,
    ]
      .filter(Boolean)
      .join(' ')

    return (
      <Tooltip title={fieldError} placement="topLeft">
        <span className={errorClassName}>{displayValue || '\u00A0'}</span>
      </Tooltip>
    )
  }

  if (!hasDiff) {
    return (
      <span className={`${styles.diffCellText} ${styles.diffCellDefault}`}>
        {formatDisplayValue(uploaded)}
      </span>
    )
  }

  const live = row.fieldCompare[fieldKey]?.liveValue
  const displayValue = formatDisplayValue(uploaded)
  const isEmpty = displayValue === ''
  const changedClassName = [
    styles.diffCellText,
    styles.diffCellChanged,
    isEmpty ? null : styles.diffCellChangedValue,
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <Tooltip
      title={
        <span>
          Database: {formatDisplayValue(live) || '(empty)'}
          <br />
          New: {displayValue || '(empty)'}
        </span>
      }
      placement="topLeft"
    >
      <span className={changedClassName}>{displayValue || '\u00A0'}</span>
    </Tooltip>
  )
}
